<template>
  <main class="kurumsal-page">
    <section class="hero">
      <div class="hero-overlay"></div>
      <div class="hero-grid">
        <div class="hero-content">
          <p class="eyebrow">Kurumsal</p>
          <h1>{{ copy.heroTitle }}</h1>
          <p class="lead">{{ copy.heroLead }}</p>
          <div class="stat-grid">
            <div
              v-for="stat in stats"
              :key="stat.label"
              class="stat-card"
            >
              <div class="stat-value">{{ stat.value }}</div>
              <div class="stat-label">{{ stat.label }}</div>
            </div>
          </div>
        </div>
        <div class="hero-panel">
          <h3>{{ copy.heroPanelTitle }}</h3>
          <ul>
            <li v-for="item in heroFocus" :key="item">{{ item }}</li>
          </ul>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="section-header">
        <p class="eyebrow">{{ copy.aboutEyebrow }}</p>
        <h2>{{ copy.aboutHeading }}</h2>
        <p class="section-lead">{{ copy.aboutLead }}</p>
      </div>
      <div class="about-grid">
        <div
          v-for="strength in strengths"
          :key="strength.title"
          class="info-card"
        >
          <h3>{{ strength.title }}</h3>
          <p>{{ strength.copy }}</p>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="section-header">
        <p class="eyebrow">{{ copy.missionEyebrow }}</p>
        <h2>{{ copy.missionHeading }}</h2>
        <p class="section-lead">{{ copy.missionLead }}</p>
      </div>
      <div class="mv-grid">
        <div class="mv-card">
          <div class="pill">Misyon</div>
          <h3>{{ copy.missionCardTitle }}</h3>
          <p>{{ copy.missionCardCopy }}</p>
          <ul>
            <li v-for="item in missionList" :key="item">{{ item }}</li>
          </ul>
        </div>
        <div class="mv-card">
          <div class="pill pill-alt">Vizyon</div>
          <h3>{{ copy.visionCardTitle }}</h3>
          <p>{{ copy.visionCardCopy }}</p>
          <ul>
            <li v-for="item in visionList" :key="item">{{ item }}</li>
          </ul>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="section-header">
        <p class="eyebrow">{{ copy.environmentEyebrow }}</p>
        <h2>{{ copy.environmentHeading }}</h2>
        <p class="section-lead">{{ copy.environmentLead }}</p>
      </div>
      <div class="policy-grid">
        <div
          v-for="policy in environmentPillars"
          :key="policy.title"
          class="policy-card"
        >
          <div class="policy-badge"></div>
          <div>
            <h3>{{ policy.title }}</h3>
            <p>{{ policy.detail }}</p>
          </div>
        </div>
      </div>
      <div class="cta-panel">
        <div>
          <h3>{{ copy.ctaTitle }}</h3>
          <p>{{ copy.ctaCopy }}</p>
        </div>
        <router-link to="/iletisim" class="cta-button">{{ copy.ctaButton }}</router-link>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'AppKurumsal',
  data() {
    return {
      copy: {
        heroTitle: 'Topra\u011fa de\u011fer, \u00fcreticiye g\u00fcven.',
        heroLead:
          'OCN G\u00fcbre \u00dcretim Pazarlama Sanayi, 2021 y\u0131l\u0131nda Samsun merkezli kuruldu. Yerel ihtiya\u00e7lara uygun, dengeli i\u00e7erikli g\u00fcbre \u00e7\u00f6z\u00fcmleriyle \u00fcreticinin verimini art\u0131r\u0131rken topra\u011f\u0131n sa\u011fl\u0131\u011f\u0131n\u0131 korumay\u0131 hedefliyoruz. May Tohum Karadeniz distrib\u00fct\u00f6rl\u00fc\u011f\u00fcm\u00fczle tohum, g\u00fcbre ve saha deste\u011fini ayn\u0131 plan i\u00e7inde bulu\u015fturuyoruz.',
        heroPanelTitle: '\u00d6nceliklerimiz',
        aboutEyebrow: 'Hakk\u0131m\u0131zda',
        aboutHeading: 'Topraktan sofraya uzanan sorumluluk',
        aboutLead:
          'Samsun merkezli \u00fcretim \u00fcss\u00fcm\u00fczden; Karadeniz ve \u0130\u00e7 Anadolu b\u00f6lgelerindeki \u00e7ift\u00e7ilerimizle yan yana \u00e7al\u0131\u015f\u0131yoruz. \u00dcr\u00fcn form\u00fclasyonlar\u0131m\u0131z\u0131 toprak analizleri, b\u00f6lgesel bitki deseni ve s\u00fcrd\u00fcr\u00fclebilir tar\u0131m ilkelerine g\u00f6re tasarl\u0131yor; May Tohum portf\u00f6y\u00fcn\u00fc Karadeniz \u00fcreticisiyle bulu\u015fturuyoruz.',
        missionEyebrow: 'Misyon & Vizyon',
        missionHeading: 'S\u00fcrd\u00fcr\u00fclebilir tar\u0131m i\u00e7in yol haritam\u0131z',
        missionLead:
          'Bilimsel temelli \u00fcretim, do\u011fru uygulama deste\u011fi ve \u015feffaf tedarik zinciri ile tar\u0131msal \u00fcretimin gelece\u011fini birlikte kuruyoruz.',
        missionCardTitle: '\u00dcreticiyi g\u00fc\u00e7lendiren dengeli besleme',
        missionCardCopy:
          'Ula\u015f\u0131labilir ve do\u011fru i\u00e7erikli g\u00fcbre \u00e7\u00f6z\u00fcmleriyle verimi, kaliteyi ve toprak sa\u011fl\u0131\u011f\u0131n\u0131 ayn\u0131 anda korumay\u0131 ama\u00e7l\u0131yoruz.',
        visionCardTitle: 'Topra\u011fa dost yenilik\u00e7i marka',
        visionCardCopy:
          '\u00c7evreye duyarl\u0131 \u00fcretim k\u00fclt\u00fcr\u00fc, dijital izlenebilirlik ve i\u015f birlikleriyle T\u00fcrkiye \u00e7ap\u0131nda s\u00fcrd\u00fcr\u00fclebilir g\u00fcbre markalar\u0131ndan biri olmak.',
        environmentEyebrow: '\u00c7evre Politikam\u0131z',
        environmentHeading: 'Topra\u011f\u0131 koruyan \u00fcretim k\u00fclt\u00fcr\u00fc',
        environmentLead:
          'Hammadde se\u00e7iminden sahadaki uygulama e\u011fitimlerine kadar her ad\u0131mda ekolojik dengeyi g\u00f6zetir, kaynak verimlili\u011fini ve izlenebilirli\u011fi \u00f6n planda tutar\u0131z.',
        ctaTitle: 'Birlikte daha ye\u015fil bir tar\u0131m i\u00e7in',
        ctaCopy:
          'Bayilerimiz ve \u00fcreticilerimizle el ele; do\u011fru \u00fcr\u00fcn, do\u011fru doz ve do\u011fru zaman yakla\u015f\u0131m\u0131yla hem verimi art\u0131r\u0131yor hem de \u00e7evreyi koruyoruz.',
        ctaButton: '\u0130leti\u015fime Ge\u00e7elim'
      },
      stats: [
        { value: '2021', label: 'Kurulu\u015f y\u0131l\u0131' },
        { value: 'Samsun', label: 'Merkez' },
        { value: 'May Tohum', label: 'Karadeniz Distrib\u00fct\u00f6r\u00fc' },
        { value: '%100 Yerli', label: '\u00dcretim ve geli\u015ftirme' }
      ],
      heroFocus: [
        'B\u00f6lgesel ihtiya\u00e7lara uygun g\u00fcbre form\u00fclasyonlar\u0131',
        'May Tohum Karadeniz distrib\u00fct\u00f6rl\u00fc\u011f\u00fc',
        'Araziye dayal\u0131 teknik dan\u0131\u015fmanl\u0131k ve e\u011fitim',
        '\u0130zlenebilir ve s\u00fcrd\u00fcr\u00fclebilir tedarik zinciri'
      ],
      strengths: [
        {
          title: 'Tohum ve g\u00fcbreyi birlikte planlama',
          copy:
            'May Tohum \u00e7e\u015fit se\u00e7imini OCN G\u00fcbre besleme programlar\u0131yla birlikte ele al\u0131r; ekimden hasada uyumlu bir sezon plan\u0131 olu\u015ftururuz.'
        },
        {
          title: 'Bilimsel yakla\u015f\u0131m',
          copy:
            'Toprak analizleri, bitki desenleri ve iklim ko\u015fullar\u0131na g\u00f6re form\u00fclasyon geli\u015ftirir; kalite kontrol s\u00fcre\u00e7lerini her partide uygular\u0131z.'
        },
        {
          title: '\u00dcreticiyle omuz omuza',
          copy:
            'Arazi ziyaretleri, demonstrasyonlar ve saha destek ekipleriyle do\u011fru dozaj ve uygulama zaman\u0131n\u0131 birlikte planlar\u0131z.'
        },
        {
          title: 'G\u00fcvenilir tedarik ve lojistik',
          copy:
            'Samsun merkezli \u00fcretim \u00fcss\u00fcm\u00fczden \u00e7evik teslimat; izlenebilir ham madde y\u00f6netimi ve s\u00fcrd\u00fcr\u00fclebilir tedarik\u00e7i ili\u015fkileri.'
        }
      ],
      missionList: [
        'Do\u011fru i\u00e7erikli ve eri\u015filebilir g\u00fcbre \u00e7\u00f6z\u00fcmleriyle \u00fcreticinin kazanc\u0131n\u0131 y\u00fckseltmek.',
        'Verimlilik, kalite ve toprak sa\u011fl\u0131\u011f\u0131n\u0131 birlikte g\u00f6zeten uygulamalar geli\u015ftirmek.',
        'Her b\u00f6lgede teknik destek ve e\u011fitimle \u00fcreticinin yan\u0131nda yer almak.'
      ],
      visionList: [
        'T\u00fcrkiye \u00e7ap\u0131nda s\u00fcrd\u00fcr\u00fclebilir g\u00fcbre markalar\u0131ndan biri olmak ve b\u00f6lgesel etkisini geni\u015fletmek.',
        'Dijital izlenebilirlik ve veri temelli dan\u0131\u015fmanl\u0131kla \u015feffaf bir \u00fcretim zinciri kurmak.',
        'Toprak dostu Ar-Ge yat\u0131r\u0131mlar\u0131yla yenilik\u00e7i \u00fcr\u00fcnler geli\u015ftirmek.'
      ],
      environmentPillars: [
        {
          title: 'D\u00fc\u015f\u00fck \u00e7evresel etki',
          detail:
            'Enerji verimli \u00fcretim, at\u0131klar\u0131n geri kazan\u0131m\u0131 ve emisyon kontrol\u00fcyle karbon ayak izimizi azalt\u0131yoruz.'
        },
        {
          title: 'Do\u011fru doz ve uygulama',
          detail:
            'Toprak ve yaprak analiziyle ihtiya\u00e7 kadar kullan\u0131m; bilin\u00e7siz ve a\u015f\u0131r\u0131 g\u00fcbrelemenin \u00f6n\u00fcne ge\u00e7me hedefi.'
        },
        {
          title: 'Sorumlu hammadde se\u00e7imi',
          detail:
            '\u0130zlenebilir tedarik\u00e7iler ve \u00e7evre standartlar\u0131na uyumlu ham maddelerle \u00fcretim yap\u0131yoruz.'
        },
        {
          title: 'E\u011fitim ve i\u015f birlikleri',
          detail:
            'Ziraat odalar\u0131, kooperatifler ve \u00fcniversitelerle ortak projelerle s\u00fcrd\u00fcr\u00fclebilir tar\u0131ma katk\u0131 sa\u011fl\u0131yoruz.'
        }
      ]
    };
  }
};
</script>

<style scoped>
.kurumsal-page {
  background: linear-gradient(180deg, #f7fafc 0%, #f1f5f9 42%, #f8fafc 100%);
  color: #0f172a;
}

.hero {
  position: relative;
  padding: 72px 0 64px;
  overflow: hidden;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: radial-gradient(120% 120% at 20% 20%, rgba(15, 118, 110, 0.2), transparent),
    radial-gradient(90% 90% at 80% 0%, rgba(15, 23, 42, 0.18), transparent);
  pointer-events: none;
}

.hero-grid {
  position: relative;
  display: grid;
  grid-template-columns: 1.6fr 1fr;
  gap: 32px;
  width: min(1180px, calc(100% - 32px));
  margin: 0 auto;
}

.hero-content {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 28px;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.1);
  backdrop-filter: blur(8px);
}

.eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  font-weight: 700;
  color: #0f766e;
  margin-bottom: 8px;
}

.eyebrow::before {
  content: '';
  width: 18px;
  height: 2px;
  background: #0f766e;
  border-radius: 999px;
}

.lead {
  margin: 14px 0 18px;
  line-height: 1.6;
  color: #1f2937;
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
  margin-top: 18px;
}

.stat-card {
  background: #0f766e;
  color: #f8fafc;
  padding: 16px;
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(15, 118, 110, 0.18);
}

.stat-value {
  font-size: 22px;
  font-weight: 800;
}

.stat-label {
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.9;
}

.hero-panel {
  background: linear-gradient(180deg, #0f172a 0%, #0f172a 70%, #111827 100%);
  color: #e2e8f0;
  border-radius: 16px;
  padding: 28px;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.28);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.hero-panel h3 {
  font-size: 18px;
  margin-bottom: 12px;
}

.hero-panel ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 10px;
}

.hero-panel li {
  position: relative;
  padding-left: 20px;
  line-height: 1.5;
}

.hero-panel li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 10px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
}

.section {
  width: min(1180px, calc(100% - 32px));
  margin: 0 auto;
  padding: 56px 0;
}

.section-header {
  text-align: left;
  margin-bottom: 22px;
}

.section-header h2 {
  font-size: 28px;
  margin: 4px 0;
  color: #0f172a;
}

.section-lead {
  color: #1f2937;
  max-width: 820px;
  line-height: 1.6;
}

.about-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
}

.info-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.info-card h3 {
  margin-bottom: 10px;
  color: #0f172a;
}

.info-card p {
  margin: 0;
  color: #334155;
  line-height: 1.6;
}

.info-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.12);
}

.mv-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.mv-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
}

.pill {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 999px;
  background: #ecfdf3;
  color: #166534;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.pill-alt {
  background: #e0f2fe;
  color: #0ea5e9;
}

.mv-card h3 {
  margin: 12px 0 8px;
  color: #0f172a;
}

.mv-card p {
  color: #334155;
  line-height: 1.6;
}

.mv-card ul {
  list-style: none;
  padding: 0;
  margin: 12px 0 0;
  display: grid;
  gap: 10px;
}

.mv-card li {
  position: relative;
  padding-left: 18px;
  color: #1f2937;
  line-height: 1.5;
}

.mv-card li::before {
  content: '\2022';
  position: absolute;
  left: 0;
  color: #0f766e;
}

.policy-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 12px;
  margin-bottom: 24px;
}

.policy-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.policy-badge {
  width: 12px;
  height: 12px;
  margin-top: 6px;
  border-radius: 50%;
  background: linear-gradient(180deg, #22c55e 0%, #0f766e 100%);
  box-shadow: 0 0 0 6px rgba(15, 118, 110, 0.08);
  flex-shrink: 0;
}

.policy-card h3 {
  margin: 0 0 6px;
  color: #0f172a;
}

.policy-card p {
  margin: 0;
  color: #334155;
  line-height: 1.55;
}

.cta-panel {
  background: #0f172a;
  color: #e2e8f0;
  border-radius: 14px;
  padding: 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.28);
}

.cta-panel h3 {
  margin: 0 0 6px;
}

.cta-panel p {
  margin: 0;
  color: #cbd5e1;
  max-width: 640px;
  line-height: 1.5;
}

.cta-button {
  background: #22c55e;
  color: #052e16;
  border-radius: 10px;
  padding: 12px 18px;
  font-weight: 700;
  text-decoration: none;
  border: 1px solid #16a34a;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 28px rgba(34, 197, 94, 0.3);
  background: #16a34a;
}

@media (max-width: 960px) {
  .hero-grid {
    grid-template-columns: 1fr;
  }

  .hero {
    padding: 56px 0;
  }

  .section {
    padding: 44px 0;
  }
}

@media (max-width: 640px) {
  .hero-content,
  .hero-panel {
    padding: 22px;
  }

  .stat-grid {
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  }

  .cta-panel {
    align-items: flex-start;
  }
}
</style>

